exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".accept-analysis .header[data-v-50917f46]{margin:20px}.accept-analysis .content .chart[data-v-50917f46]{width:500px;margin:0 auto;height:400px}\n", ""]);

// exports
